import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=2117a91a&scoped=true"
import script from "./Exercise.vue?vue&type=script&lang=js"
export * from "./Exercise.vue?vue&type=script&lang=js"
import style0 from "./Exercise.vue?vue&type=style&index=0&id=2117a91a&prod&scoped=true&lang=scss"
import style1 from "./Exercise.vue?vue&type=style&index=1&id=2117a91a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2117a91a",
  null
  
)

export default component.exports